<template>
  <b-modal
    v-model="model"
    size="md"
    hide-footer
    centered
    @show="loadProducts"
  >
    <h1 class="font-large-1 text-center pt-2">
      Pedido interno
    </h1>
    <validation-observer ref="job-expected-cost-line-internal-order-form">
      <b-form
        class="py-2"
        @submit.prevent
      >
        <b-row align-h="center">
          <b-col
            sm="12"
            lg="10"
          >
            <validation-provider
              v-slot="validationContext"
              name="Producto"
              rules="required"
            >
              <b-form-group
                label="Producto"
                label-for="product"
              >
                <v-select
                  id="product"
                  v-model="product"
                  :options="products"
                  :loading="loadingProducts"
                  label="name"
                  @input="handleProductSelected"
                />
                <small class="text-danger">{{ validationContext.errors[0] }}</small>
                <small v-if="productInfo && productInfo.purchase_price > 0" class="text-muted">
                  Precio {{ productInfo.purchase_price | numberToLocalString }} € / {{ productInfo.units || '-' }}
                </small>
              </b-form-group>
            </validation-provider>
            <b-form-group
              label="Unidades"
              label-for="units"
            >
              <b-form-input
                id="units"
                :value="unitsDisplay"
                placeholder="0,00"
                @keydown="handleUnitsKeydown"
                @input="handleUnitsInput"
              />
              <validation-provider
                v-slot="validationContext"
                name="Unidades"
                rules="required|min_value:1"
              >
                <b-form-input
                  v-model="unitsNumeric"
                  class="d-none"
                />
                <small class="text-danger">{{ validationContext.errors[0] }}</small>
              </validation-provider>
              <small v-if="productInfo && productInfo.units" class="text-muted d-block">
                Introducir en {{ productInfo.units }}
              </small>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <b-row align-h="center">
        <b-col cols="auto">
          <b-button
            variant="primary"
            class="text-nowrap rounded-sm px-2"
            @click="handleAcceptButtonClick"
          >
            Guardar
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-modal>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'JobExpectedCostLineInternalOrderModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      product: null,
      unitsDisplay: null,
      unitsNumeric: null,
      products: [],
      loadingProducts: false,
      productInfo: null,
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    handleUnitsKeydown(event) {
      const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End']
      if (allowed.includes(event.key)) return
      if (!/^[0-9,]$/.test(event.key)) {
        event.preventDefault()
      }
    },
    handleUnitsInput(value) {
      let sanitized = value.replace(/[^0-9,]/g, '')
      const parts = sanitized.split(',')
      if (parts.length > 2) {
        sanitized = parts[0] + ',' + parts.slice(1).join('')
      }
      if (parts[1] !== undefined) {
        sanitized = parts[0] + ',' + parts[1].slice(0, 2)
      }
      this.unitsDisplay = sanitized
      this.unitsNumeric = sanitized ? parseFloat(sanitized.replace(',', '.')) || null : null
    },
    async handleProductSelected(product) {
      this.productInfo = null
      if (!product) return
      try {
        const response = await Vue.prototype.$http.get(`/products/${product.id}`)
        this.productInfo = response.data.data || response.data
      } catch (error) {
        console.error(error)
      }
    },
    async loadProducts() {
      this.product = null
      this.unitsDisplay = null
      this.unitsNumeric = null
      this.productInfo = null
      this.loadingProducts = true
      try {
        const response = await Vue.prototype.$http.post('/products/internal-products-list')
        this.products = response.data.data || response.data
      } catch (error) {
        console.error(error)
      } finally {
        this.loadingProducts = false
      }
    },
    async handleAcceptButtonClick() {
      const valid = await this.$refs['job-expected-cost-line-internal-order-form'].validate()
      if (!valid) {
        return
      }

      this.$emit('input', false)
      this.$emit('create-internal-order', { product: this.product, units: this.unitsNumeric })
    },
  },
}
</script>
